export const mutations = {
    setUser(state, user) {
      state.user = user;
    },
    setUserPermissions(state, permissions) {
      state.userPermissions = permissions;
    },
    setUserRoles(state, roles) {
      state.roles = roles;
    },
    setSupervisorNotifications(state, notification) {
      state.notifications = notification;
    },
    updateSupervisorNotification(state, updatedNotification) {
      const index = state.notifications.findIndex(n => n.id === updatedNotification.id);
      if (index !== -1) {
          state.notifications.splice(index, 1, updatedNotification);
      }
    },
}
